module.exports = window["MaterialUiPhoneNumber"];